import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetServiceContractDelegationList } from "DelegationService/DelegationService/Domain/Responses/ServiceContractDelegation/GetServiceContractDelegationList";

export async function getServiceContractDelegationListService(data) {
    let response = await getAPIResponse("/v1/service-contract-delegation-list", data);
    if (response === null) {
        return null;
    }
    let getServiceContractDelegationList = GetServiceContractDelegationList.createFromResponseData(response);
    return getServiceContractDelegationList;
}